<template lang="pug">
  div(class="hero theme-2 mt-5")

    .corner
      img(src="https://ik.imagekit.io/aryraditya/ceremonyku/corner_2x_sZXnEWtgp.png?tr=w-500")

    .container.py-3
      
      div.px-3
        h1(class="text-center text-uppercase") Mepandes
        .name
          .title Sumi, Siska 
            span.d-block(style="line-height: 1") &
            | Ayu Trisna
          
        guest-box(:floating="false" class="mx-auto")
    
    div(class="container-xl")
      swiper(:options="swiperOptions" ref="mySwiper")
        swiper-slide(v-for="image in images" :key="image")
          img(:data-src="image" :key="image" class="img-fluid swiper-lazy")
          .swiper-lazy-preloader.swiper-lazy-preloader-white
        .swiper-button-prev(slot="button-prev")
        .swiper-button-next(slot="button-next")
        //- .swiper-pagination(slot="pagination")
        //- .swiper-scrollbar(slot="scrollbar")
</template>

<script>

import { swiper, swiperSlide } from 'vue-awesome-swiper'
import GuestBox from '@/components/GuestBox'

export default {
  components: {
    swiper,
    swiperSlide,
    GuestBox
  },
  props: ['images'],
  data: () => ({
    swiperOptions: {
      effect: 'fade',
      lazy: true,
      loop: true,
      autoplay: {
        delay: 2000
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        clickable: true,
      },

    }
  }),
  computed: {
    title: function() {
      const title = this.$parent.title

      if(this.$parent.mepandes.length) {
        title += '& Mepandes' 
      }

      return title
    }
  }
};
</script>

<style scoped>
.guest-box {
  display: block;
  border: 1px solid #ccc;
  font-size: 90%
}
h1 {
  letter-spacing: 4px;
  font-size: 1.5rem !important;
  font-weight: lighter;
}

.hero.theme-2 {
  overflow: hidden;
  position: relative;
  margin-top: 0 !important;
  padding-top: 4rem;
}

.hero.theme-2 .corner {
  width: 300px !important;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(30%, -20%);
  z-index: -1;
  opacity: .4;
}
</style>